import React, { useState, useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";

const LoginButton = () => {
    const { loginWithRedirect } = useAuth0();

    return <button className="navbar-btn btn btn-sm btn-primary me-1 bg-success" onClick={() => loginWithRedirect({ screen_hint: 'sign up' })}>Get Started <i className="fe fe-arrow-right"></i></button>;
};

export default LoginButton;